export default __webpack_public_path__ + "static/media/joined-hands.ba4b66cc.jpeg";